import React from "react";
import { RCCAlert, RCCButton, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IIndicatorsMetrics, IIndicatorsValues } from "src/pages/Indicators/Panel/components/interface";
import TooltipIndicators from "src/pages/Indicators/Panel/components/TooltipIndicatorPanel/tooltip";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";

interface IData{
	values: IIndicatorsValues;
	evaluationForm: number;
	metrics: IIndicatorsMetrics;
}

const DashboardGaugeIndicators: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	
	const { data, loading } = card?.daa002Idorigem ? useEffectFetchData<IData> (
		"DashboardIndicators/SelectIndicator", 
		{ id: card?.daa002Idorigem }
	): { data: undefined, loading: true };


	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Indicadores medidor")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to={`/indicators/panel/${card?.daa002Idorigem}`}>
					<RCCTooltip
						text={translate("Painel de indicadores")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="indicators"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to={`/indicators/presentation/selected/${card?.daa002Idorigem}`}>
					<RCCTooltip
						text={translate("Apresentação de indicadores")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "presentationChartBar",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>


			<DefaultBody>
				{!card?.daa002Idorigem ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("É necessário selecionar um indicador")}
					/>
				) : (
					<>
						{data && (
							<TooltipIndicators 
								value={{
									...data.values,
									iqc001Formaaval: data.evaluationForm,
									metrics: data.metrics
								}} 
								styleInline={`
										background: transparent;
										border: none;
										box-shadow: none;
										width: 100%;
										min-width: 100%;
										padding: 0;
				
										&:hover{
											cursor: pointer;
										}
				
										>div{
											padding: 0;
											
											&:first-child{
												border: none;
											}
										}
									`}
							/>
						)}
					</>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardGaugeIndicators;
